import { Pagination, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { NavigatesAndAgreement } from 'features/vacations/navigatesAndAgreement';
import { usePath, useScrollUpPage } from 'shared/hooks';
import { VacationsModel } from 'entities/vacations';
import { TColumns, TUnionTableData } from 'shared/types/types';
import { RowSelectionType } from 'antd/lib/table/interface';
import { TPreparedAbsenceData } from 'shared/types/absence.types';
import { TConsultationsPreparedData } from 'shared/types/consultations.types';
import SearchComponent from 'shared/components/search/news-faq';
import { SearchKeysNews } from 'shared/enums/news';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TProps = {
  dataSource: TUnionTableData;
  columns: TColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  rowSelectionType?: RowSelectionType;
  onSearch?: (data: string, key: SearchKeysNews) => void;
};

export const TableInProgress = ({
  dataSource,
  columns,
  currentPage,
  setCurrentSize,
  setCurrentPage,
  currentSize,
  total,
  rowSelectionType = 'radio',
  onSearch,
}: TProps) => {
  const mainPath = usePath(1);
  const dispatch = useAppDispatch();
  const [selectUser, setSelectUser] = useState<TUnionTableData>([]);

  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: TUnionTableData) => {
      setSelectUser(selectedRows);
      if (mainPath === 'vacation') {
        dispatch(VacationsModel.SelectedVacation.actions.selectedVacation({ ...selectedRows[0] }));
      }
    },
  };

  const getCheckboxProps = (record: TUnionTableData[number]) => ({
    disabled:
      mainPath === 'absence' &&
      ((record as TPreparedAbsenceData).zupRequestStatus !== null ||
        (record as TPreparedAbsenceData).status.type === 'rejectedByHR'),
  });

  useScrollUpPage(currentPage);

  useEffect(() => {
    const key = dataSource.find(item => item?.key === selectUser[0]?.key);
    if (!key) {
      setSelectUser([]);
    }
  }, [dataSource]);

  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysNews.SEARCH_NAME]: {
            name: SearchKeysNews.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysNews.SEARCH_ID]: {
            name: SearchKeysNews.SEARCH_ID,
            alias: 'Номер заявки',
            node: NumberFormItem({
              name: SearchKeysNews.SEARCH_ID,
              placeholder: 'Введите номер заявки',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_ID);
              },
            }),
          },
          [SearchKeysNews.PERSONNEL_NUMBER]: {
            name: SearchKeysNews.PERSONNEL_NUMBER,
            alias: 'ТН',
            node: StringFormItem({
              name: SearchKeysNews.PERSONNEL_NUMBER,
              placeholder: 'Введите ТН',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.PERSONNEL_NUMBER);
              },
            }),
          },
          [SearchKeysNews.POSITION_NAME]: {
            name: SearchKeysNews.POSITION_NAME,
            alias: 'Должность',
            node: StringFormItem({
              name: SearchKeysNews.POSITION_NAME,
              placeholder: 'Введите должность',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.POSITION_NAME);
              },
            }),
          },
          [SearchKeysNews.DIVISION_NAME]: {
            name: SearchKeysNews.DIVISION_NAME,
            alias: 'Подразделение',
            node: StringFormItem({
              name: SearchKeysNews.DIVISION_NAME,
              placeholder: 'Введите подразделение',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.DIVISION_NAME);
              },
            }),
          },
        }}
      />
      {selectUser?.length > 0 && dataSource?.length > 0 && (
        <NavigatesAndAgreement
          id={`${selectUser[0].key}`}
          ids={selectUser.length > 1 ? selectUser.map(item => item.id) : undefined}
          tabKey="my"
          setSelectUser={setSelectUser}
          currentPage={currentPage}
          currentSize={currentSize}
        />
      )}

      <Table
        scroll={{ x: true }}
        rowSelection={{
          selectedRowKeys: selectUser.map(item => item.id),
          type: rowSelectionType,
          getCheckboxProps,
          ...rowSelection,
        }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        rowClassName={record => {
          if (!('consultant' in record) || (record as TConsultationsPreparedData).isHRReplied) {
            return '';
          }
          if (record.downtimeStatus === 'red') {
            return style.red;
          } else if (record.downtimeStatus === 'yellow') {
            return style.yellow;
          }
          return style.blue;
        }}
      />
      <div className={style.paginationWrap}>
        <Pagination
          showSizeChanger
          defaultCurrent={currentSize}
          current={currentPage}
          pageSize={currentSize}
          total={total}
          onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
        />
      </div>
    </>
  );
};
